import type { Template } from "@/content/templates/template.types";
import { JiraTemplateCategoryPageTemplate } from "@/templates/software/jira/templates/service-management/jira-templates-page/src";

export type JiraTemplateCategoryPageProps = {
    templates?: Template[];
};

export const JiraTemplateCategoryPage = ({
    templates
}: JiraTemplateCategoryPageProps) => (
    <JiraTemplateCategoryPageTemplate templates={templates} />
);
